var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0137 1C12.2898 1 12.5137 1.22386 12.5137 1.5V4.01623C16.5288 4.27066 19.7394 7.48697 19.9849 11.5045H22.5C22.7761 11.5045 23 11.7284 23 12.0045C23 12.2807 22.7761 12.5045 22.5 12.5045H19.9843C19.7344 16.5209 16.5209 19.7344 12.5046 19.9843V22.5C12.5046 22.7761 12.2807 23 12.0046 23C11.7284 23 11.5046 22.7761 11.5046 22.5V19.9849C7.48092 19.7391 4.26094 16.5191 4.01509 12.4955H1.5C1.22386 12.4955 1 12.2716 1 11.9955C1 11.7193 1.22386 11.4955 1.5 11.4955H4.01565C4.26598 7.47301 7.4888 4.25589 11.5137 4.01454V1.5C11.5137 1.22386 11.7375 1 12.0137 1ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.d9cacfe9e5a5c0f858182605a16a6d86.svg";
export { ForwardRef as ReactComponent };